module.exports = __webpack_public_path__ + "img/complete.5071d07e.png";